import {withStyles} from '@material-ui/core/styles'
import {ToggleButtonGroup} from '@material-ui/lab'

export default withStyles(
  {
    root: {
      width: '100%',
    },
    groupedHorizontal: {
      '&:not(:first-child)': {
        borderTopLeftRadius: 'inherit',
        borderBottomLeftRadius: 'inherit',
      },
      '&:not(:last-child)': {
        borderTopRightRadius: 'inherit',
        borderBottomRightRadius: 'inherit',
      },
    },
  },
  {name: 'LPCTogglePlateGroup'},
)(ToggleButtonGroup)
